import services from 'services/module';
import {HttpSvcFactory, HttpSvc} from './HttpSvc';

export class NewsSvc {
    delayUpdateNews = 36e+5;
    currentIndex = 0;
    newsList: any[] = [];
    deferRun = true;
    deferRunTimer = 1000;
    stopUpdateNews: ng.IPromise<any>;
    currentUser: anm.User;
    httpNews: HttpSvc<any>;

    constructor(private $interval: ng.IIntervalService,
                private $timeout: ng.ITimeoutService,
                private HttpSvc: HttpSvcFactory,
                private LocalStorageSvc: any) {
        this.httpNews = HttpSvc('news');
    }

    isEqualUsers(user: anm.User) {
        const copyUser = angular.copy(user);
        delete copyUser.auth;
        const isEqual = this.currentUser ? _.isEqual(this.currentUser, copyUser) : false;
        this.currentUser = copyUser;
        return isEqual;
    }

    onUserChanged(user: anm.User) {
        if (this.isEqualUsers(user)) return;

        if (this.deferRun) {
            this.$timeout(() => {
                this.getNews();
                this.deferRun = false;
            }, this.deferRunTimer);
        } else {
            this.getNews();
        }
    }

    getNews() {
        const httpNews = this.httpNews.chain(new Date().getTimezoneOffset());
        this.newsList = [];
        const request = options.user.anonymous ? httpNews.get() : httpNews.secureGet();
        request.then(r => r.data).then(res => this.newsList = options.user.anonymous ? this.getWhiteList(res) : res);

        this.$interval.cancel(this.stopUpdateNews);
        this.stopUpdateNews = this.$interval(() => this.getNews(), this.delayUpdateNews);
    }

    getWhiteList(NewsList: any[]) {
        const deletedNewsList = this.LocalStorageSvc.get('deletedNewsList');

        if (deletedNewsList) {
            return NewsList.filter((newsItem) => !_.contains(deletedNewsList, newsItem.id));
        }
        return NewsList;
    }

    addDeletedItemId(deleteId: string) {
        const deletedNewsList = this.LocalStorageSvc.get('deletedNewsList') || [];
        deletedNewsList.push(deleteId);
        this.LocalStorageSvc.set('deletedNewsList', deletedNewsList);
    }

    deleteNews(id: string) {
        if (_.isEmpty(this.newsList)) return;
        const deleteNews = _.findWhere(this.newsList, {id});
        this.newsList = _.without(this.newsList, deleteNews);
        if (options.user.anonymous) {
            this.addDeletedItemId(deleteNews.id);
        } else {
            this.httpNews.chain(deleteNews.id).secureDelete();
        }
    }
}

services.service('NewsSvc', NewsSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/NewsSvc.ts